import axios from "axios";

const config = (language, token, branchOfficeId = "", orderId = "") => {
  if (token) {
    return {
      headers: {
        'Accept-Language': language,
        'Authorization': 'Bearer ' + token,
        'x-branchOffice-id': branchOfficeId,
        'x-order-id': orderId
      }
    }
  } else {
    return { headers: { 'Accept-Language': language } }
  }
}


const configTestNvp = (token) => {
  return {
    headers: {
      'Authorization': 'Bearer ' + token,
    }
  }
}

const configLogin = () => {
  return { headers: { 'content-type': 'application/x-www-form-urlencoded' } }
}


const getBaseUrl = (name) => {
  switch (name) {
    case 'purch':
      return process.env.REACT_APP_PURCHASE
    case 'mainten':
      return process.env.REACT_APP_MAINTENANCE
    case 'indirect':
      return process.env.REACT_APP_INDIRECT
    case 'collateral':
      return process.env.REACT_APP_COLLATERAL
    case 'telematics':
      return process.env.REACT_APP_TELEMATICS
    case 'extapis':
      return process.env.REACT_APP_APIS
    case 'tokenNvp':
      return process.env.REACT_APP_FETCH_TOKEN_NVP
    case 'downloadAnnexB':
      return process.env.REACT_APP_DOWNLOAD_ANNEXB
    case 'notification':
      return process.env.REACT_APP_LOG
    case 'othertransactions':
      return process.env.REACT_APP_OTHERTRANSACTIONS
    case 'catalogs':
      return process.env.REACT_APP_CATALOGS
    default:
  }
}

export default {
  PurchaseOrders() {
    return {
      fetchDashboard: (lang, token, supplierId) => axios.get(getBaseUrl('purch') + `GetPurchaseDashboard?supplierId=${supplierId}`, config(lang, token, supplierId)),
      fetchOCByStatus: (lang, token, status, startDate, endDate, filter, supplierId) => axios.get(getBaseUrl('purch') + `GetListByStatus?supplierId=${supplierId}&status=${status}&start=${startDate ? startDate : ''}&end=${endDate ? endDate : ''}&filter=${filter}`, config(lang, token, supplierId)),
      fetchOrderDetail: (lang, token, orderId) => axios.get(getBaseUrl('purch') + `GetPurchaseOrderDetail?orderId=${orderId}`, config(lang, token, "", orderId)),
      fetchInvoiceErrors: (lang, token, orderId) => axios.get(getBaseUrl('purch') + `GetInvoiceErrors?orderId=${orderId}`, config(lang, token, "", orderId)),
      fetchOrderDocuments: (lang, token, orderId) => axios.get(getBaseUrl('purch') + `GetOrderDocuments?orderId=${orderId}`, config(lang, token, "", orderId)),
      saveDeliveryDates: (lang, token, orderId, deliveryDates) => axios.post(getBaseUrl('purch') + `SavePurchaseOrderDeliveryDates?orderid=${orderId}`, deliveryDates, config(lang, token, "", orderId)),
      uploadInvoice: (lang, token, orderId, values) => axios.post(getBaseUrl('purch') + `UploadInvoice`, values, config(lang, token, "", orderId)),
      uploadEvidence: (lang, token, orderId, values) => axios.post(getBaseUrl('purch') + `UploadEvidence`, values, config(lang, token, "", orderId)),
      DeleteEvidence: (lang, token, evidenceId, orderId, nameInContainer) => axios.delete(getBaseUrl('purch') + `Evidence?evidenceId=${evidenceId}&orderId=${orderId}&NameInContainer=${nameInContainer}`, config(lang, token, "", orderId)),
      DeleteInvoice: (lang, token, invoiceId, orderId) => axios.delete(getBaseUrl('purch') + `Invoice?InvoiceId=${invoiceId}`, config(lang, token, "", orderId)),
      DeleteRight: (lang, token, rightId, orderId) => axios.delete(getBaseUrl('purch') + `Right?RightId=${rightId}`, config(lang, token, "", orderId)),
      uploadAnnexB: (lang, token, orderId, values) => axios.post(getBaseUrl('purch') + `AnnexB`, values, config(lang, token, "", orderId)),
      findQuadrant: (lang, token, supplierId, orderNumber) => axios.get(getBaseUrl('purch') + `WhereIsOrder?supplierId=${supplierId}&orderNumber=${orderNumber}`, config(lang, token, supplierId)),
      getInvoiceTypeOptions: (lang, token, orderId, remainingAmount) => axios.get(getBaseUrl('purch') + `GetInvoiceTypeOptions?orderId=${orderId}&remainingAmount=${remainingAmount}`, config(lang, token, "", orderId)),
      validateVIN: (lang, token, orderId, values) => axios.post(getBaseUrl('purch') + `ValidateVIN`, values, config(lang, token, "", orderId)),
      downloadDocument: (lang, token, documentId, orderId, documentType) => axios({
        method: 'get',
        url: getBaseUrl('purch') + `DownloadDocument?documentId=${documentId}&documentType=${documentType}`,
        responseType: 'blob',
        headers: {
          'Accept-Language': lang,
          'Authorization': 'Bearer ' + token,
          'x-branchOffice-id': "",
          'x-order-id': orderId
        }
      }),
      downloadEvidence: (lang, token, documentId, orderId) => axios({
        method: 'get',
        url: getBaseUrl('purch') + `DownloadEvidence?documentId=${documentId}`,
        responseType: 'blob',
        headers: {
          'Accept-Language': lang,
          'Authorization': 'Bearer ' + token,
          'x-branchOffice-id': "",
          'x-order-id': orderId
        }
      }),
      downloadOrderDetails: (lang, token, orderId) => axios({
        method: 'get',
        url: getBaseUrl('purch') + `DownloadOrderDetails?orderId=${orderId}`,
        responseType: 'json',
        headers: {
          'Accept-Language': lang,
          'Authorization': 'Bearer ' + token,
          'x-branchOffice-id': "",
          'x-order-id': orderId
        }
      }),
      downloadDocumentAnnexB: (lang, token, folio, orderId) => axios({
        method: 'get',
        url: getBaseUrl('purch') + `AnnexB?folio=${folio}`,
        responseType: 'json',
        headers: {
          'Accept-Language': lang,
          'Authorization': 'Bearer ' + token,
          'x-branchOffice-id': "",
          'x-order-id': orderId
        }
      }),
      testConnectionNvp: (token, value) => axios.post('http://10.3.128.11:51956/api/v1/PurchaseOrderController/test', value, configTestNvp(token)),
      fetchStageId: (lang, token, nvpQuoteMultipleUnits) => axios.get(getBaseUrl('purch') + `GetStagePOByIdNVP?nvpQuoteMultipleunits=${nvpQuoteMultipleUnits}`, config(lang, token, nvpQuoteMultipleUnits))
    }
  },
  UserProfile() {
    return {
      fetchUserProfile: (lang, token) => axios.get(getBaseUrl('extapis') + 'UserProfile/Get', config(lang, token)),
      getToken: (data) => axios.post(getBaseUrl('auth') + 'connect/token', data, configLogin())
    }
  },
  Maintenance() {
    return {
      fetchDashboard: (lang, token, branchOfficeId) => axios.get(getBaseUrl('mainten') + `GetMaintenanceOrderStatus?branchOfficeId=${branchOfficeId}`, config(lang, token, branchOfficeId)),
      fetchOCByStatus: (lang, token, status, startDate, endDate, filter, branchOfficeId) => axios.get(getBaseUrl('mainten') + `GetListByStatus?status=${status}&start=${startDate ? startDate : ''}&end=${endDate ? endDate : ''}&filter=${filter}&branchOfficeId=${branchOfficeId}`, config(lang, token, branchOfficeId)),
      fetchEvidence: (lang, token, orderId, option) => axios.get(getBaseUrl('mainten') + `GetListEvidence?orderNumber=${orderId}&option=${option}`, config(lang, token, "", orderId)),
      uploadEvidence: (lang, token, orderId, file, option) => axios.post(getBaseUrl('mainten') + `UploadEvidence?orderId=${orderId}&option=${option}`, file, config(lang, token, "", orderId)),
      DeleteEvidence: (lang, token, evidenceId, orderId, option) => axios.delete(getBaseUrl('mainten') + `DeleteEvidence?evidenceId=${evidenceId}&orderId=${orderId}&option=${option}`, config(lang, token, "", orderId)),
      uploadInvoice: (lang, token, orderId, files) => axios.post(getBaseUrl('mainten') + `UploadInvoice?orderNumber=${orderId}`, files, config(lang, token, "", orderId)),
      uploadMarkupInvoice: (lang, token, orderId, files) => axios.post(getBaseUrl('mainten') + `UploadMarkupInvoice?orderNumber=${orderId}`, files, config(lang, token, "", orderId)),
      fetchOrderDetail: (lang, token, orderId) => axios.get(getBaseUrl('mainten') + `GetOrderDetail?orderNumber=${orderId}`, config(lang, token, "", orderId)),
      UploadComplement: (lang, token, orderId, file) => axios.post(getBaseUrl('mainten') + `UploadComplement?orderNumber=${orderId}`, file, config(lang, token, "", orderId)),
      fetchInvoiceHistory: (lang, token, orderId) => axios.get(getBaseUrl('mainten') + `GetInvoiceHistoryList?orderId=${orderId}`, config(lang, token, "", orderId)),
      fetchInvoiceComplement: (lang, token, orderId) => axios.get(getBaseUrl('mainten') + `GetInvoicesComplement?orderNumber=${orderId}`, config(lang, token, "", orderId)),
      fetchRejectedInvoice: (lang, token, orderId) => axios.get(getBaseUrl('mainten') + `GetReyectedInvoices?orderNumber=${orderId}`, config(lang, token, "", orderId)),
      DeleteRejectedInvoice: (lang, token, invoiceId) => axios.delete(getBaseUrl('mainten') + `DeleteReyectedInvoice?invoiceId=${invoiceId}`, config(lang, token, "", invoiceId))
    }
  },
  Indirect() {
    return {
      fetchDashboard: (lang, token, branchOfficeId) => axios.get(getBaseUrl('indirect') + `GetCountTypesOrdes`, config(lang, token, branchOfficeId)),
      fetchOCByStatus: (lang, token, status, startDate, endDate, filter, branchOfficeId) => axios.get(getBaseUrl('indirect') + `GetPurchaseOrders?status=${status}&start=${startDate ? startDate : ''}&end=${endDate ? endDate : ''}&filter=${filter}`, config(lang, token, branchOfficeId)),
      fetchBranchOffices: (lang, token, orderId) => axios.get(getBaseUrl('indirect') + `GetBranchOffice`, config(lang, token, "", orderId)),
      AddBranchOfficeToOrder: (lang, token, branchOfficeId, orderId) => axios.post(getBaseUrl('indirect') + `UpdateBranchOfficeIdInOrder?branchOfficeId=${branchOfficeId}&orderId=${orderId}`, "", config(lang, token, branchOfficeId, orderId)),
      fetchOrderDetails: (lang, token, orderId) => axios.get(getBaseUrl('indirect') + `GetOrderDetails?orderId=${orderId}`, config(lang, token, "", orderId)),
      fetchRejectedInvoice: (lang, token, orderId) => axios.get(getBaseUrl('indirect') + `GetReyectedInvoicesIndirect?orderId=${orderId}`, config(lang, token, "", orderId)),
      DeleteRejectedInvoice: (lang, token, invoiceId) => axios.delete(getBaseUrl('indirect') + `DeleteReyectedInvoiceIndirect?invoiceId=${invoiceId}`, config(lang, token, "", invoiceId)),
      uploadInvoice: (lang, token, orderId, files) => axios.post(getBaseUrl('indirect') + `UploadIndirectInvoice?oderId=${orderId}`, files, config(lang, token, "", orderId)),
      fetchInvoiceHistory: (lang, token, orderId) => axios.get(getBaseUrl('indirect') + `GetIndirectInvoiceHistoryList?orderId=${orderId}`, config(lang, token, "", orderId)),
      UploadComplement: (lang, token, orderId, file) => axios.post(getBaseUrl('indirect') + `UploadIndirectComplement?orderId=${orderId}`, file, config(lang, token, "", orderId)),
      fetchInvoiceComplement: (lang, token, orderId) => axios.get(getBaseUrl('indirect') + `GetIndirectInvoicesComplement?orderId=${orderId}`, config(lang, token, "", orderId)),
      AddSupplier: (lang, token, orderId, supplierId) => axios.post(getBaseUrl('indirect') + `AddSupplier?orderId=${orderId}&supplierId=${supplierId}`, config(lang, token, "", orderId)),
    }
  },
  Collateral() {
    return {
      //*DashBoards
      fetchDashboard: (lang, token, branchOfficeId) => axios.get(getBaseUrl('collateral') + `Counters?branchOfficeID=${branchOfficeId}`, config(lang, token, branchOfficeId)),
      findQuadrant: (lang, token, branchOfficeId, orderNumber) => axios.get(getBaseUrl('collateral') + `WhereIsOrder?branchOfficeID=${branchOfficeId}&orderNumber=${orderNumber}`, config(lang, token, branchOfficeId)),
      fetchOCByStatus: (lang, token, branchOfficeId, stage) => axios.get(getBaseUrl('collateral') + `OrdersList?branchOfficeID=${branchOfficeId}&stage=${stage}`, config(lang, token, "", "")),
      fetchOCByFilter: (lang, token, startDate, endDate, filter, stage, branchOfficeId) => axios.get(getBaseUrl('collateral') + `OrdersListByFilter?start=${startDate ? startDate : ''}&end=${endDate ? endDate : ''}&filter=${filter}&stage=${stage}&branchOfficeID=${branchOfficeId}`, config(lang, token, "", "", "", "")),
      //*WorkOrder
      fetchWorkOrderDetail: (lang, token, branchOfficeID, woID, stage) => axios.get(getBaseUrl('collateral') + `OrderDetail?branchOfficeID=${branchOfficeID}&wOId=${woID}&stage=${stage}`, config(lang, token, "", "")),
      DownloadWorkOrderPDF: (lang, token, branchOfficeID, woID) => axios({
        method: 'get',
        url: getBaseUrl('collateral') + `DownloadOrderDetail?branchOfficeID=${branchOfficeID}&wOId=${woID}`,
        responseType: 'json',
        headers: {
          'Accept-Language': lang,
          'Authorization': 'Bearer ' + token,
          'x-branchOffice-id': "",
          'x-woID': woID
        }
      }),
      //*Substages
      fetchSubstage: (lang, token, stageId) => axios.get(getBaseUrl('collateral') + `SubStages?StageId=${stageId}`, config(lang, token, "")),
      fetchSubstagePerOrder: (lang, token, orderId, branchOfficeId) => axios.get(getBaseUrl('collateral') + `SubStagesPerOrder?OrderNumber=${orderId}&branchOfficeID=${branchOfficeId}`, config(lang, token, "")),
      saveSubStage: (lang, token, saveSubStageBody) => axios.post(getBaseUrl('collateral') + `SaveCollateralSubStageOrder`, saveSubStageBody, config(lang, token, "")),
      changeState: (lang, token, changeStateBody) => axios.post(getBaseUrl('collateral') + `ChangeStage`, changeStateBody, config(lang, token, "")),
      deleteSubstage: (lang, token, subStageId, branchOfficeId, orderNumber) => axios.delete(getBaseUrl('collateral') + `SubStage?SubStageId=${subStageId}&BranchOfficeId=${branchOfficeId}&OrderNumber=${orderNumber}`, config(lang, token, "")),
      //*Rigths
      fetchRigths: (lang, token) => axios.get(getBaseUrl('collateral') + `ProceduresCatalog`, config(lang, token, "")),
      fetchRigthsPerOrder: (lang, token, orderId) => axios.get(getBaseUrl('collateral') + `ProcedureByOrder?WOID=${orderId}`, config(lang, token, "")),
      saveRigths: (lang, token, saveRigthsBody) => axios.post(getBaseUrl('collateral') + `UploadEvidence`, saveRigthsBody, config(lang, token, "")),
      deleteRight: (lang, token, procedureId, procedureDocumentId, orderNumber, branchOfficeId) => axios.delete(getBaseUrl('collateral') + `Procedure?ProcedureId=${procedureId}&ProcedureDocumentId=${procedureDocumentId}&OrderNumber=${orderNumber}&BranchOfficeId=${branchOfficeId}`, config(lang, token, "")),
      //*Comments
      fetchComments: (lang, token, woID, branchOfficeId) => axios.get(getBaseUrl('collateral') + `Comments?woid=${woID}&BranchOfficeId=${branchOfficeId}`, config(lang, token, "", "")),
      postComments: (lang, token, postCommentsBody) => axios.post(getBaseUrl('collateral') + `UploadComment`, postCommentsBody, config(lang, token, "")),
      deleteComment: (lang, token, wocId, orderNumber, branchOfficeId) => axios.delete(getBaseUrl('collateral') + `Comment?WocId=${wocId}&OrderNumber=${orderNumber}&BranchOfficeId=${branchOfficeId}`, config(lang, token, "")),    
      CommentDocumentDownload: (lang, token, woid) => axios.get(getBaseUrl('collateral') + `CommentDocument?WOCommentId=${woid}`, config(lang, token, "")),
      //*Invoice
      uploadInvoice: (lang, token, invoice) => axios.post(getBaseUrl('collateral') + `UploadInvoice`, invoice, config(lang, token, "")),
      fetchErrors: (lang, token, woid) => axios.get(getBaseUrl('collateral') + `InvoiceErrors?orderNumber=${woid}`, config(lang, token, "")),
      fetchInvoices: (lang, token, woid) => axios.get(getBaseUrl('collateral') + `Invoices?orderNumber=${woid}`, config(lang, token, "")),
      //*Plates
      fetchStatePlate: (lang, token) => axios.get(getBaseUrl('collateral') + `StatePlate`, config(lang, token, "", "")),
      fetchTypePlate: (lang, token) => axios.get(getBaseUrl('collateral') + `TypePlate`, config(lang, token, "", "")),
      fetchWOProcedurePlate: (lang, token, woid) => axios.get(getBaseUrl('collateral') + `WOProcedurePlate?woid=${woid}`, config(lang, token, "", "")),

    }
  },
  Telematics() {
    return {
      //*Dashboards
      fetchDashboard: (lang, token, branchOfficeId) => axios.get(getBaseUrl('telematics') + `Counters?branchOfficeID=${branchOfficeId}`, config(lang, token, branchOfficeId)),
      fetchOCByStatus: (lang, token, branchOfficeId, stage) => axios.get(getBaseUrl('telematics') + `InstallationOrdersList?BranchOfficeID=${branchOfficeId}&Status=${stage}`, config(lang, token, "", "")),
      fetchFilterByDate: (lang, token, startDate, endDate, status, branchOfficeId, filter) => axios.get(getBaseUrl('telematics') + `InstallatonOrdersListByFilter?branchOfficeID=${branchOfficeId}&status=${status}&start=${startDate ? startDate : ''}&end=${endDate ? endDate : ''}&filter=${filter}`, config(lang, token, "", "", "", "", "", "")),
      fetchFilterByText: (lang, token, branchOfficeId, stage, filter) => axios.get(getBaseUrl('telematics') + `InstallatonOrdersListByFilter?branchOfficeID=${branchOfficeId}&status=${stage}&filter=${filter}`, config(lang, token, "", "", "")),
      //*OrderDetail
      fetchInstallationOrderDetail: (lang, token, branchOfficeID, installationOrderId) => axios.get(getBaseUrl('telematics') + `InstallationOrderDetail?BranchOfficeID=${branchOfficeID}&InstallationOrderId=${installationOrderId}`, config(lang, token, "", "")),
      DownloadOrderDetailPDF: (lang, token, branchOfficeID, installationOrderId) => axios({
        method: 'get',
        url: getBaseUrl('telematics') + `InstallationOrderDocumment?BranchOfficeID=${branchOfficeID}&InstallationOrderId=${installationOrderId}`,
        responseType: 'json',
        headers: {
          'Accept-Language': lang,
          'Authorization': 'Bearer ' + token,
          'x-branchOffice-id': "",
          'x-installationOrderId': installationOrderId
        }
      }),
      //*Technicians
      fetchTechnicians: (lang, token, branchOfficeId) => axios.get(getBaseUrl('telematics') + `Installers?branchOfficeId=${branchOfficeId}`, config(lang, token)),
      filterTechnicians: (lang, token, branchOfficeId, filterTechnician) => axios.get(getBaseUrl('telematics') + `Installers?branchOfficeId=${branchOfficeId}&name=${filterTechnician}`, config(lang, token, "")),
      saveTechnicians: (lang, token, saveTechnician) => axios.post(getBaseUrl('telematics') + `Installers`, saveTechnician, config(lang, token, "")),
      updateTechnicians: (lang, token, technicianId, updateTechnician) => axios.patch(getBaseUrl('telematics') + `Installers/${technicianId}`, updateTechnician, config(lang, token, "")),
      deleteTechnicians: (lang, token, deleteTechnician) => axios.delete(getBaseUrl('telematics') + `Installers/${deleteTechnician}`, config(lang, token, "")),
      fetchPhoneTypes: (lang, token) => axios.get(getBaseUrl('telematics') + `PhoneTypes`, config(lang, token)),
      asignTechnician: (lang, token, orderId, installerId) => axios.post(getBaseUrl('telematics') + `InstallationOrders/${orderId}/Installers/${installerId}`, "", config(lang, token, "")),
      fetchTechniciansOrders: (lang, token) => axios.get(getBaseUrl('telematics') + `Installers/InstallationOrders`, config(lang, token)),

      fetchTechniciansByOrder: (lang, token, orderNumber) => axios.get(getBaseUrl('telematics') + `InstallersByOrder?orderNumber=${orderNumber}`, config(lang, token)),
      deleteAssignedTechnician: (lang, token, installerId, orderInstallationId) => axios.delete(getBaseUrl('telematics') + `DeallocateInstaller?InstallerId=${installerId}&OrderInstallationId=${orderInstallationId}`, config(lang, token, "")),

      //*Invoices
      fetchViaticDocuments: (lang, token, instalationId, isViatic) => axios.get(getBaseUrl('telematics') + `InstallationOrderDocuments?orderNumber=${instalationId}&isViatic=${isViatic}`, config(lang, token)),
      UploadInvoiceOrder: (lang, token, files) => axios.post(getBaseUrl('telematics') + `UploadInvoiceOrder`, files, config(lang, token, "")),
      DownloadDocument: (lang, token, documentId, isService) => axios({
        method: 'get',
        url: getBaseUrl('telematics') + `DownloadDocument?documentId=${documentId}&isService=${isService}`,
        responseType: 'json',
        headers: {
          'Accept-Language': lang,
          'Authorization': 'Bearer ' + token
        }
      }),
      fetchInvoiceErrors: (lang, token, orderNumber) => axios.get(getBaseUrl('telematics') + `ErrorDocument?orderNumber=${orderNumber}`, config(lang, token)),
      deleteViaticDocument: (lang, token, instalationId, documentId) => axios.delete(getBaseUrl('telematics') + `InvoiceOrder?instalationId=${instalationId}&documentId=${documentId}`, config(lang, token, "")),
      //*Services
      fetchInvoiceServiceDocuments: (lang, token, serviceNumber) => axios.get(getBaseUrl('telematics') + `InstallationServiceDocuments?serviceNumber=${serviceNumber}`, config(lang, token)),
      fetchServiceEvidenceById: (lang, token, serviceId) => axios.get(getBaseUrl('telematics') + `Service/${serviceId}/Evidence`, config(lang, token)),
      UploadInvoiceService: (lang, token, files) => axios.post(getBaseUrl('telematics') + `UploadInvoiceService`, files, config(lang, token, "")),
      UploadServiceEvidence: (lang, token, serviceId, file) => axios.post(getBaseUrl('telematics') + `Service/${serviceId}/Evidence`, file, config(lang, token, "")),
      deleteEvidence: (lang, token, serviceId, evidenceId) => axios.delete(getBaseUrl('telematics') + `Service/${serviceId}/Evidence?serviceEvidenceId=${evidenceId}`, config(lang, token, "")),
      deleteServiceDocument: (lang, token, serviceNumber, documentId) => axios.delete(getBaseUrl('telematics') + `InvoiceService?documentId=${documentId}&serviceNumber=${serviceNumber}`, config(lang, token, "")),
      UploadWorkCompleted: (lang, token, data, serviceId) => axios.post(getBaseUrl('telematics') + `Service/${serviceId}/Complete`, data, config(lang, token, "")),
      UploadExcelInvoiceToServices: (lang, token, file) => axios.post(getBaseUrl('telematics') + `UploadExcelInvoice`, file, config(lang, token, "")),
      //*installation orders
      acceptOrDeclineInstallationOrder: (lang, token, orderId, acceptOrder) => axios.post(getBaseUrl('telematics') + `InstallationOrders/${orderId}/AcceptDecline`, acceptOrder, config(lang, token, ""))
    }
  },
  Notifications() {
    return {
      fetchNotificationStatus: (lang, token, poId, unitId, notified) => axios.get(getBaseUrl('notification') + `GetApplicationLogStatus?purchaseOrderId=${poId}&idNvpQuoteUnits=${unitId}&notified=${notified}`, config(lang, token)),
      fetchNotificationDetail: (lang, token, poId, unitId, notified) => axios.get(getBaseUrl('notification') + `GetApplicationLog?purchaseOrderId=${poId}&idNvpQuoteUnits=${unitId}&notified=${notified}`, config(lang, token)),
      updateNotificationStatus: (lang, token, poId, unitId, notified, userId) => axios.post(getBaseUrl('notification') + `UpdateApplicationLog?purchaseOrderId=${poId}&idNvpQuoteUnits=${unitId}&supplierNotifReadInd=${notified}&auditUpdateUser=${userId}`, "", config(lang, token, "", poId)),

    }
  },
  Supplier() {
    return {
      downloadOC: (lang, token, supplierId, nvpQuoteMultipleUnit, consecutive) => axios.post(getBaseUrl('extapis') + `ThirdParty/Supplier/GeneratePO?supplierId=${supplierId}&nvpQuoteMultipleUnit=${nvpQuoteMultipleUnit}&consecutive=${consecutive}`, "", config(lang, token))
    }
  },
  Order() {
    return {
      //*DashBoards
      fetchDashboard: (lang, token, branchOfficeId) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetOrderBoard?branchOfficeID=${branchOfficeId}`,
          config(lang, token, branchOfficeId)),
      fetchListPage: (lang, token, values) =>
        axios.post(
          getBaseUrl('othertransactions') + `GetOrderPage`,
          values,
          config(lang, token)
        ),
      fetchOrderDetail: (lang, token, id) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetOrderDetail?pymtOrdId=${id}`,
          config(lang, token, id)),
      fetchOrderReceiptsByOrder: (lang, token, id) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetOrderReceiptsByOrder?pymtOrdId=${id}`,
          config(lang, token, id)),
      fetchReceiptServicesFreeByOrder: (lang, token, id) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetReceiptServicesFreeByOrder?pymtOrdId=${id}`,
          config(lang, token, id)),
      saveReceipt: (lang, token, body) =>
        axios.post(getBaseUrl('othertransactions') + `UploadReceipt`, body,
          config(lang, token, "")),
      UpdateOrderInvoice: (lang, token, orderId, files) =>
        axios.post(
          getBaseUrl('othertransactions') + `UploadOrderInvoice?orderNumber=${orderId}`, files,
          config(lang, token, "", orderId)),
      GetInvoiceByOrder: (lang, token, orderId) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetInvoiceByOrder?orderNumber=${orderId}`,
          config(lang, token, orderId)),
      DeleteDocumentsInvoiceByOrder: (lang, token, orderId) =>
        axios.delete(
          getBaseUrl('othertransactions') + `DeleteDocumentsInvoiceByOrder?orderNumber=${orderId}`,
          config(lang, token, orderId)),
      DeleteOrderReceiptsByOrder: (lang, token, pymtOrdReceiptId, pymtOrdId) =>
        axios.delete(
          getBaseUrl('othertransactions') + `DeleteOrderReceiptsByOrder?pymtOrdReceiptId=${pymtOrdReceiptId}&pymtOrdId=${pymtOrdId}`,
          config(lang, token, pymtOrdReceiptId, pymtOrdId)),
      fetchOrderDetail: (lang, token, id) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetOrderDetail?pymtOrdId=${id}`,
          config(lang, token, id)),
      fetchOrderReceiptsByOrder: (lang, token, id) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetOrderReceiptsByOrder?pymtOrdId=${id}`,
          config(lang, token, id)),
      fetchReceiptServicesFreeByOrder: (lang, token, id) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetReceiptServicesFreeByOrder?pymtOrdId=${id}`,
          config(lang, token, id)),
      saveReceipt: (lang, token, body) =>
        axios.post(getBaseUrl('othertransactions') + `UploadReceipt`, body,
          config(lang, token, "")),
      UpdateOrderInvoice: (lang, token, orderId, files) =>
        axios.post(
          getBaseUrl('othertransactions') + `UploadOrderInvoice?orderNumber=${orderId}`, files,
          config(lang, token, "", orderId)),
      GetInvoiceByOrder: (lang, token, orderId) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetInvoiceByOrder?orderNumber=${orderId}`,
          config(lang, token, orderId)),
      DownloadDocumentById: (lang, token, values) =>
        axios.post(
          getBaseUrl('othertransactions') + `DownloadDocument`,
          values,
          config(lang, token)
        ),
      UpdateStatusOrderReviewPayment: (lang, token, id,advancePymtRequestId) =>
        axios.get(
          getBaseUrl('othertransactions') + `UpdateStatusOrderReviewPayment?pymtOrdId=${id}&advancePymtRequestId=${advancePymtRequestId}`,
          config(lang, token, id)),
      DownloadExcelOrders: (lang, token, values) =>
        axios.post(
          getBaseUrl('othertransactions') + `DownloadOrdersExcel`,
          values,
          config(lang, token)
        ),
      GetAdvanceDetail: (lang, token, advancePymtRequestId) =>
        axios.get(
          getBaseUrl('othertransactions') + `GetAdvanceDetail?AdvancePymtRequestId=${advancePymtRequestId}`,
          config(lang, token, advancePymtRequestId)),
    }
  },
  Catalogs() {
    return {
      fetchSupplierById: (lang, token, SupplierId) =>
        axios.get(getBaseUrl('catalogs') + `GetSupplierById?id=${SupplierId}`, config(lang, token)),
      fetchContractServiceCode: (lang, token, SupplierId) =>
        axios.get(getBaseUrl('catalogs') + `GetContractServiceCode?id=${SupplierId}`, config(lang, token)),
    }
  },
}